import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    initialize() {
        super.initialize();
    }

    static values = {
        activeDay: Number,
    }
    connect() {
        this.isApp = this.element.querySelector('.app-schedules') !== null;
        this.currentTimeout = null;
        this.clubSelector = this.element.querySelector('#clubSelector');
        this.workoutSelector = this.element.querySelector('#workoutSelector');
        this.dateSelector = this.element.querySelector('#dateSelector');
        this.currentWeekDay = this.element.dataset.weekday;

        if (!this.isApp) {
            this.header = this.element.querySelector('#schedulesHeader');
            this.body = this.element.querySelector('#schedulesBody');
            this.arrowPrev = this.element.querySelector('.header__navigation-prev');
            this.arrowNext = this.element.querySelector('.header__navigation-next');

            const isInTabs = this.element.classList.contains('tab-content');

            if (isInTabs) {
                // Handle tabbed schedule
                if (!this.element.classList.contains('active')) {
                    const observer = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.target.classList.contains('active')) {
                                this.initializeSchedule();
                            }
                        });
                    });

                    observer.observe(this.element, {
                        attributes: true,
                        attributeFilter: ['class']
                    });
                } else {
                    this.initializeSchedule();
                }
            } else {
                // Handle single schedule
                this.initializeSchedule();
            }
        } else {
            this.daySelector = this.element.querySelector('#daySelector');

            this.daySelector.querySelectorAll('.day-box').forEach((dayBox) => {
                dayBox.addEventListener('click', () => {
                    this.daySelector.querySelectorAll('.day-box').forEach((dayBox) => {
                        dayBox.classList.remove('active');
                    });
                    dayBox.classList.add('active');
                    this.currentWeekDay = dayBox.dataset.value;
                    this.updateVisibleCells(this.workoutSelector.value, dayBox.dataset.value);
                });
            });
        }

        if (this.workoutSelector) {
            this.workoutSelector.addEventListener('change', () => {
                this.updateVisibleCells(this.workoutSelector.value, this.currentWeekDay);
            })
        }
    }

    initializeSchedule() {
        this.startingOffset = 5;
        this.slideWidth = this.body.clientWidth;
        this.slideMaxWidth = this.body.scrollWidth - this.body.clientWidth;

        this.body.addEventListener('scroll', () => {
            this.updateArrows();
        });

        this.syncScroll();
        this.initAutoScroll();
        this.updateArrows();
    }

    updateVisibleCells(workoutIds = null, weekday = null) {
        workoutIds = JSON.parse(workoutIds);
        if (workoutIds || weekday) {
            for (const cell of this.element.querySelectorAll('.workout')) {
                let active = false;

                if (this.isApp) {
                    if (weekday && (weekday === -1 || weekday === cell.dataset.weekday)) {
                        if (workoutIds !== -1) {
                            active = Object.values(workoutIds).includes(cell.dataset.workout) // Combine with existing active state
                        } else {
                            active = true;
                        }
                    }
                } else {
                    if (workoutIds) {
                        if (workoutIds === -1 || workoutIds.length === 0 || Object.values(workoutIds).includes(cell.dataset.workout)) {
                            active = true;
                        }
                    }

                }

                if (active) {
                    cell.classList.remove('d-none');
                } else {
                    cell.classList.add('d-none');
                }
            }

            for (const row of this.element.querySelectorAll('.body__row')) {
                if (row.querySelector('.workout:not(.d-none)')) {
                    row.classList.remove('d-none');
                } else {
                    row.classList.add('d-none');
                }
            }
        }
    }

    initAutoScroll() {
        const body = this.element.querySelector('.body');
        if (screen.width > 576) {
            return;
        }
        let weekday;
        if (this.activeDayValue) {
            weekday = this.activeDayValue;
        } else {
            weekday = new Date().getDay();
        }
        weekday = weekday === 0 ? 7 : weekday;
        body.scrollLeft += this.slideWidth * (weekday-1);
    }

    syncScroll() {
        const bindSyncScrolling = (one, two) => {
            let echo = false,
                sync = (one, two) => () =>
                    (echo = !echo) && (
                        one.scrollTop = two.scrollTop,
                            one.scrollLeft = two.scrollLeft
                    )
            ;
            two.onscroll = sync(one, two);
            one.onscroll = sync(two, one);
        };
        bindSyncScrolling(this.header, this.body)
    }

    scrollPrev() {
        let currentScroll = this.body.scrollLeft;

        if (currentScroll <= this.startingOffset) {
            return;
        }

        clearTimeout(this.currentTimeout);
        this.body.scrollLeft -= this.slideWidth;
        this.updateArrows();
    }

    scrollNext() {
        let currentScroll = this.body.scrollLeft;
        let maxScroll = this.body.scrollWidth - this.body.clientWidth;

        if (currentScroll >= maxScroll - this.startingOffset) {
            return;
        }

        clearTimeout(this.currentTimeout);
        this.body.scrollLeft += this.slideWidth;
        this.updateArrows();
    }

    updateArrows() {
        this.currentTimeout = setTimeout(() => {
            let currentScroll = this.body.scrollLeft;
            let maxScroll = this.body.scrollWidth - this.body.clientWidth;

            if (currentScroll <= this.startingOffset) {
                this.arrowPrev.classList.add('disabled');
            } else {
                this.arrowPrev.classList.remove('disabled');
            }

            if (currentScroll >= maxScroll - this.startingOffset) {
                this.arrowNext.classList.add('disabled');
            } else {
                this.arrowNext.classList.remove('disabled');
            }
        }, 500) //Wait for smooth scroll to end, broken without it
    }

    refreshWithValue(e) {
        const element = e.currentTarget;

        const url = new URL(window.location);
        url.searchParams.delete('encoded')
        url.searchParams.set(element.name, element.value)
        url.searchParams.set('paged', '1')
        window.location.href = url.href;
    }
}
